<template>
<div class="inside_pages_right">
    <VisitorMachineManagement></VisitorMachineManagement>
    <!-- 临时访客人员库 -->
    <div class="inside_pages_right_content">
        <div class="inside_pages_right_content_top">
            <div class="inside_pages_right_content_top_left">
                <el-tag type="warning">温馨提示：临时访客有效时间仅当日有效，超过时间需重新登记访客信息，才允许入校</el-tag>
            </div>
            <div class="inside_pages_right_content_top_right">
                人员编号：<el-input v-model="requestData.number" placeholder="请输入人员编号" size="mini"></el-input>
                访客姓名：   <el-input v-model="requestData.number" placeholder="请输入访客姓名" size="mini"></el-input>
                入库状态：
                <el-select v-model="requestData.status" placeholder="入库状态" size="mini">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="上传成功" value="0"></el-option>
                    <el-option label="已失效" value="1"></el-option>
                </el-select>&nbsp;
                <el-button type="primary" size="mini">查询</el-button>
            </div>
        </div>
        <div class="inside_pages_right_content_center">
            <el-table  :data="responseData.list" height="100%"  border style="width: 100%" @selection-change="selectDeleteData">
                <el-table-column type="selection" width="40"> 
                </el-table-column>
                <el-table-column  prop="id" label="编号">
                </el-table-column>

                <el-table-column  prop="name1" label="访客姓名"  >
                </el-table-column>

                <el-table-column  prop="name2" label="性别">
                </el-table-column>

                <el-table-column  prop="name3" label="人像">
                    <template slot-scope="scope">
                        <div v-if="scope.row.name3 == 0">暂无二人像信息</div>
                        <div v-if="scope.row.name3 != 0" class="demo-image__preview">
                            <el-image 
                                style="width: 100px; height: 100px" :src="$store.state.config.fileUrl+scope.row.name3" 
                                :preview-src-list="[$store.state.config.fileUrl+scope.row.name3]">
                            </el-image>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column  prop="name4" label="人员编号">
                </el-table-column>

                <el-table-column  prop="name5" label="身份证号">
                </el-table-column>

                <el-table-column  prop="date1" label="加入日期" width="100">
                    <template slot-scope="rowData">
                        {{$Common.dateFormatDate(rowData.row.date1)}}
                    </template>
                </el-table-column>

                <el-table-column  prop="name6" label="入库状态">
                </el-table-column>

                <el-table-column  label="操作" column-key="index" width="300">
                    <template slot-scope="scope">
                        <el-button type="primary"  size="mini" plain  icon="el-icon-edit-outline">
                            编辑
                        </el-button>
                        <el-button type="primary"  size="mini" plain  icon="el-icon-circle-close" >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="inside_pages_right_content_bottom">
            <div class="block">
            <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="responseData.pageNum"
            :page-sizes="[20, 30, 50, 100]"
            :page-size="20"
            layout="total, sizes, prev, pager, next, jumper"
            prev-text="上一页"
            next-text="下一页"
            :total="responseData.total">
            </el-pagination>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import VisitorMachineManagement from '@/components/VisitorMachineManagement'
export default {
    name:'',
    components: {VisitorMachineManagement},
    props: {},
    data() {
        return {
            // 批量删除安全小组的ID列表
            delDataList:[],

            // 数据列表
            responseData: {
                pageNum:1,        // 第几页
                pageSize:20,      // 一页多少个
                total:0,      // 总条数
                pages:0,     // 总页数
                list:[
                    {
                        id:123,
                        name1: '访客姓名测试',
                        name2: '性别测试',
                        name3: 'images/20200702/4bfc2300ec804852af8afdd2922d3d76.png',
                        name4: '人员编号测试',
                        name5: '身份证号测试',
                        date1: 1593273599,
                        name6: '已失效',
                    }, 
                    {
                        id:123,
                        name1: '访客姓名测试',
                        name2: '性别测试',
                        name3: 'images/20200702/4bfc2300ec804852af8afdd2922d3d76.png',
                        name4: '人员编号测试',
                        name5: '身份证号测试',
                        date1: 1593273599,
                        name6: '已失效',
                    }, 
                    {
                        id:123,
                        name1: '访客姓名测试',
                        name2: '性别测试',
                        name3: 'images/20200702/4bfc2300ec804852af8afdd2922d3d76.png',
                        name4: '人员编号测试',
                        name5: '身份证号测试',
                        date1: 1593273599,
                        name6: '已失效',
                    }, 
                    {
                        id:123,
                        name1: '访客姓名测试',
                        name2: '性别测试',
                        name3: 'images/20200702/4bfc2300ec804852af8afdd2922d3d76.png',
                        name4: '人员编号测试',
                        name5: '身份证号测试',
                        date1: 1593273599,
                        name6: '已失效',
                    }, 
                ],    
            },

            // 请求参数
            requestData :{
                pageNum : 1,
                pageSize : 20,
                number: null,
                name: null,
                status: null,
            },

        };
    },
    watch: {
    },
    computed: {},
    methods: {

     
        // 数据显示每页的条数
        handleSizeChange(val) {
            this.requestData.pageSize = val
            this.getDataList()
           
        },

        // 数据翻页
        handleCurrentChange(val) {
            this.requestData.pageNum = val
            this.getDataList()
        },
       
        // 选择数据
        selectDeleteData(val) {
            this.delDataList = []
            for(var i = 0;i<val.length;i++){
                this.delDataList.push(val[i].id)
                
            }
            // console.log(this.delDataList);
        },

        // 删除
        delDataInfo(thisId=0){
            this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                if(thisId>=1){
                    var requestData = [thisId]
                }else{

                    if(this.delDataList.length < 1){
                        this.$message({
                            type: 'error',
                            message: '请先选择您要删除的数据'
                        });
                        return false
                    }
                    var requestData = this.delDataList
                }

                
                let res =  await  this.$Http.delClassCamera(requestData)
                if(res.code == 200){
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getDataList()
                }else if(res.code == 101){

                } else {
                    this.$message({
                        type: 'error',
                        message: res.messsage
                    });
                }
               
            }).catch(() => {}); 
        },

     
    },
    created() {},
    mounted() {
    }
};
</script>
<style scoped>
</style>